
import Undo from "../../../assets/outline/Undo.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UndoIcon({ className, dataTestid = "UndoIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Undo data-testid={dataTestid} className={classes} {...rest} />
  );
}
